import { onView, onMount, onDestroy } from "@/modules/_";
import { OffsetConfig, parseOffsetConfig } from "@/utils/formatters";
import gsap from "@lib/gsap";

export default function (element: HTMLElement, dataset: DOMStringMap) {
  // const offset = element.getAttribute("data-offset");
  // const delayValue = dataset.delay;
  // let delay = 0;
  // let config: OffsetConfig | null = null;
  // if (offset) {
  //   config = parseOffsetConfig(offset);
  // }
  // gsap.set(element, {
  //   opacity: 0,
  // });
  // if (element.closest(".header_wrap")) {
  //   delay = 0.2;
  // }
  // if (delayValue) {
  //   delay = Number(delayValue);
  // }
  // const observer = onView(element, {
  //   root: null,
  //   rootMargin: "0px",
  //   threshold: 0.2,
  //   autoStart: false,
  //   once: true,
  //   callback: ({ isIn }) => {
  //     if (isIn) {
  //       gsap.to(element, {
  //         opacity: 1,
  //         duration: 1.2,
  //         ease: "smooth",
  //         delay,
  //       });
  //       if (config) {
  //         gsap.from(element, {
  //           ...config,
  //           duration: 1,
  //           delay,
  //         });
  //       }
  //     }
  //   },
  // });
  // onMount(() => {
  //   observer.start();
  // });
  // onDestroy(() => {
  //   observer.destroy();
  // });
}
